import { useMemo, useState } from "react";
import { connect } from "react-redux";
import { MegaphoneIcon, XMarkIcon } from "@heroicons/react/20/solid";
import { format } from "date-fns";

const BuddyNotifications = ({ notifications }) => {
	const [close, setClosed] = useState(false);

	const dayString = useMemo(() => {
		return format(new Date(), "yyyy-MM-dd");
	}, [new Date().toISOString()]);

	const notification = useMemo(() => {
		return notifications?.find(({ start, end, id }) => {
			const closed = window.localStorage.getItem(id);

			if (closed) return false;

			const ended = end ? dayString >= end : false;
			const started = start ? dayString >= start : true;

			if (started && !ended && !closed) return true;
		});

	}, [close, dayString, JSON.stringify(notifications)]);

	if (!notification) return null;

	return (
		<div
			style={{
				backgroundColor: "#ea611c",
				borderColor: "#ea611c",
				lineHeight: "2.5rem",
				width: "100%",
				color: "white",
				paddingLeft: "15px",
				paddingRight: "15px",
			}}
		>
			<MegaphoneIcon style={{ display: "block", height: "1.5em", float: "left", marginRight: 5, marginTop: 5 }} />

			<span
				style={{
					marginTop: "0.375rem",
					whiteSpace: "nowrap",
					textOverflow: "ellipsis",
					overflow: "hidden",
					display: "inline-block",
					maxWidth: "calc(100% - 100px)",
				}}
			>
				{notification.text}
			</span>
			<span
				style={{
					marginTop: "0.375rem",
					whiteSpace: "nowrap",
					textOverflow: "ellipsis",
					overflow: "hidden",
					display: "inline-block",
				}}
			>
				{notification.link && (
					<a
						href={notification.link}
						target="_blank"
						style={{
							fontWeight: "bold",
							textDecoration: "underline",
							color: "white",
							marginLeft: 10,
						}}
					>
						{
						notification.override ?
						<>{notification.override}</>
						: <>Learn more <span aria-hidden="true">→</span></>
					}
					</a>
				)}
			</span>
			<span
				onClick={() => {
					window.localStorage.setItem(notification.id, true);
					setClosed(notification?.id);
				}}
				style={{ float: "right", cursor: "pointer" }}
			>
				<XMarkIcon
					style={{ marginTop: 10 }}
					className="h-6 w-6 mr-3 text-white"
				/>
			</span>
		</div>
	);
};

const mapStateToProps = (state) => {
	const notifications = [
		{
			id: "7c109e86-2a49-43cc-b327-2b3b58253e8d",
			text: "Unpacking the 2024 Budget: The impact on Payroll & your teams.",
			override: "Join our webinar on 7 Nov @ 09:30 →",
			end: "2023-11-07",
			link: "https://www.buddy.hr/webinar/unpacking-the-2024-budget-the-impact-on-payroll-your-teams-tickets-745073915137"
		},
		{
			id: "57f76f08-5281-5c38-91f7-6eea9320249d",
			text: "Buddy’s offices will be closed on September 6th between 3pm and 5pm, and all day on September 15th. Support operations will resume regularly on other business days.",
			end: "2023-09-07",
		},
		{
			id: "87b15da0-5856-5e1e-b9a5-87c3b3cf554f",
			text: "Buddy’s offices will be closed on Friday, 15th of September. Our Support Team will resume regular operations on the following Monday, 18th of September.",
			start: "2023-09-06",
			end: "2023-09-16",
		},
		{
			id: "920574e5-6708-4cda-a098-8b3ce1aa582c",
			text: "Get Buddy Payroll Certified.",
			link: "https://www.buddy.hr/learn/buddy-payroll-certified",
		},
	];

	return {
		notifications,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {};

	// return ({
	//   selectBundle: () => dispatch(PAYMENTACTIONS.selectBundle(bundle)),
	// })
};

export default connect(mapStateToProps, mapDispatchToProps)(BuddyNotifications);
